import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import { Redirect } from "react-router-dom";

import { resetPassword } from "../../actions/authActions";
import {
  Form,
  FormGroup,
  FormControl,
  ButtonSubmit,
  SuccessMessage,
  ErrorMessage,
} from "../../styles/form";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const H1 = styled.h1`
  font-size: 1.5rem;
`;

class ResetPasswordForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

    this.state = {
      password: "",
      confirmPassword: "",
      loading: false,
    };
  }

  handleInputChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setState({ loading: true });

    const urlParts = document.location.pathname.split("/");
    const token = urlParts[urlParts.length - 1];
    await this.props.resetPassword(this.state.password, token);

    this.setState({ loading: false });
  }

  render() {
    if (this.props.user) {
      return <Redirect to="/companies" />;
    }

    return (
      <React.Fragment>
        <Wrapper>
          <Form onSubmit={this.handleSubmit}>
            <H1>Set Password</H1> <br />
            {this.props.success_message ? (
              <SuccessMessage>{this.props.success_message}</SuccessMessage>
            ) : null}
            {this.props.fail_message ? (
              <ErrorMessage>{this.props.fail_message}</ErrorMessage>
            ) : null}
            <FormGroup controlid="Password">
              <FormControl
                name="password"
                autoFocus
                type="password"
                placeholder="New Password"
                value={this.state.password}
                required
                onChange={this.handleInputChange}
              />
            </FormGroup>
            <FormGroup controlid="ConfirmPassword">
              <FormControl
                name="confirmPassword"
                type="password"
                placeholder="Confirm New Password"
                value={this.state.confirmPassword}
                required
                onChange={this.handleInputChange}
              />
            </FormGroup>
            <p
              style={{
                color: "red",
                fontSize: "0.7em",
                marginBottom: "12px",
              }}
            >
              {this.state.password.length < 6
                ? "Password must be at least 6 characters"
                : this.state.password !== this.state.confirmPassword
                ? "Passwords don't match"
                : null}
            </p>
            <ButtonSubmit
              disabled={
                this.state.loading ||
                this.state.password.length < 6 ||
                this.state.password !== this.state.confirmPassword
              }
              type="submit"
              value="Update"
            ></ButtonSubmit>
          </Form>
        </Wrapper>
        <p style={{ textAlign: "center", marginTop: "20px" }}>
          <a href="/">Back to login</a>
        </p>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    fail_message: state.auth.fail_message,
    success_message: state.auth.success_message,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ resetPassword }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/pages/ResetPassword.js